<template>
  <v-app>
    <v-main style="padding:0px">
      <router-view/>
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: 'App',

  created() {
    //this.$store.dispatch('permission/fetchPermission');
  }
}
</script>

<style lang="scss">
@import "@/sass/app.scss";
</style>
